import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import ErrorBoundary from './components/ErrorBoundary';
import store, { persistor } from './store';
import App from './App';

// translation init
import './i18n';
import Loader from './components/Loader';
import { ErrorBlock } from './components/Block';

export default function Root() {
  return (
    <ErrorBoundary
      fallback={
        <ErrorBlock headerText="Error">
          <button className="btn" onClick={() => window.location.reload()}>
            Reload
          </button>
        </ErrorBlock>
      }
      severity={'fatal'}
    >
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <Router>
            <Suspense fallback={<Loader />}>
              <App />
            </Suspense>
          </Router>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}
